import { useEffect, useState } from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';

export default function Switcher() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const html = document.documentElement;
    const storedTheme = localStorage.getItem('theme');

    // Kullanıcının önceki seçimi varsa onu kullan
    if (storedTheme) {
      const dark = storedTheme === 'dark';
      setIsDark(dark);
      html.classList.toggle('dark', dark);
      return;
    }

    // // Yoksa sistem temasını baz al
    // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    // setIsDark(prefersDark);
    // html.classList.toggle('dark', prefersDark);
  }, []);

  const handleThemeToggle = () => {
    const html = document.documentElement;
    const newTheme = !isDark;

    setIsDark(newTheme);
    html.classList.toggle('dark', newTheme);
    localStorage.setItem('theme', newTheme ? 'dark' : 'light');
  };

  return (
    <div className="fixed top-1/4 -right-3 z-50">
      <span className="relative inline-block rotate-90">
        <input
          type="checkbox"
          className="checkbox opacity-0 absolute"
          id="chk"
          checked={isDark}
          onChange={handleThemeToggle}
        />
        <label
          className="label bg-slate-900 dark:bg-white shadow dark:shadow-gray-800 cursor-pointer rounded-full flex justify-between items-center p-1 w-14 h-8"
          htmlFor="chk"
        >
          <FiMoon className="size-4 text-yellow-500" />
          <FiSun className="size-4 text-yellow-500" />
          <span
            className="ball bg-white dark:bg-slate-900 rounded-full absolute top-[2px] left-[2px] size-7 transition-all"
            style={{ transform: isDark ? 'translateX(24px)' : 'translateX(0)' }}
          ></span>
        </label>
      </span>
    </div>
  );
}
